import { render, staticRenderFns } from "./L1.vue?vue&type=template&id=8b181652&"
import script from "./L1.vue?vue&type=script&lang=js&"
export * from "./L1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports